import React from "react";
import { number1 } from "../numbers";

export default function FreeID() {
    return (
        <div className="idSection">
            <div className="idTransparentBG">
                <div className="idLeft">
                    <p class="idpline">Make Real Money online from World Cup to IPL</p>
                    <h2 class="listHed">Cricket Matches with SuryaBhai</h2>
                    <div>
                        <ul class="blist">
                            <li>
                                Safe and trusted Betting service
                            </li>
                            <li>
                                Quick deposit and withdraw from SuryaBhai Platform
                            </li>
                            <li>
                                Daily Offers & Bonuses
                            </li>
                        </ul>
                    </div>
                    <a target="_blank" href={`https://wa.me/91${number1}`} class="claimButton golden-btn">Get your free ID Here</a>
                </div>
                <div className="idRight">
                    <div className="info1">
                        <div className="infoCards">
                            <div class="icon_box">
                                <img src="./support-male.webp" alt="" title="" height="54" />
                            </div>
                            24*7 customer service available on SuryaBhai Platform.
                        </div>
                        <div className="infoCards">
                            <div class="icon_box">
                                <img src="./protection-secure.webp" alt="" title="" width="54" height="45" />
                            </div>
                            Your information is 100% secure with SuryaBhai Platform.
                        </div>
                    </div>
                    <div className="info2">
                        <div className="infoCards">
                            <div class="icon_box">
                                <img src="./payment-method.webp" alt="" title="" width="54" height="54" />
                            </div>
                            Accepts multiple payment on our betting website SuryaBhai Platform.
                        </div>
                        <div className="infoCards">
                            <div class="icon_box">
                                <img src="./shield.svg" alt="" title="" width="54" height="54" />
                            </div>
                            Opportunity to earn 10X rewards.
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
